import script from "./LeadsCallsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadsCallsModal.vue?vue&type=script&setup=true&lang=js"

import "./LeadsCallsModal.vue?vue&type=style&index=0&id=567c596c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-567c596c"]])

export default __exports__